import React from 'react';
import excelIcon from "../../assets/images/icons/excel-icon.svg";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const Index = ({table, filename}) => {
	return (
		<div className="excel-btn">
			<img src={excelIcon} alt="" width="50px" height="50px" />
			<ReactHTMLTableToExcel
				id="test-table-xls-button"
				className="download-table-xls-button"
				table={table}
				filename={filename}
				sheet="tablexls"
				buttonText="Скачать нa EXCEL"
			/>
		</div>
	);
};

export default Index;
